// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 3540 ? "npm.embla-carousel" : chunkId) + "." + {"1569":"3edb38b1e23326d5","3540":"04dd7539f83067eb","5499":"7573d9333c877c35","5519":"36741cb7a0910aee","6024":"3ef2304103896fea","7173":"7cd8cc4a33eb23e1","7390":"0e7fc9dec2cdfe55","8872":"8cb3fed4c5ce9c09"}[chunkId] + ".js";
};